var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-dynamic-chart',{attrs:{"chart_data":_vm.data,"attributes":_vm.attrs,"count":"2"},on:{"slide_click":_vm.eventraised,"page_change":_vm.eventraised,"navigation_click":_vm.eventraised}})}
var staticRenderFns = []

export { render, staticRenderFns }